import { Moment } from 'moment-timezone';
import { ShipmentGroup } from '../../models/shipment-group';

export default function* getPalletBoxesFromShipmentGroup(
  shipmentGroup: ShipmentGroup,
  palletBoxCounts: number[],
  now: Moment,
) {
  let carrierAccountName = '';

  const timestamp = now.format('HH:mm:ss');
  const palletBoxCountsItr = palletBoxCounts[Symbol.iterator]();

  for (const { id, name, shipmentCount } of shipmentGroup.internalShipmentGroups) {
    if (shipmentCount === 0) {
      continue;
    }

    const palletBoxCount = palletBoxCountsItr.next().value;
    const shipmentLimit = Math.floor(shipmentCount / palletBoxCount);
    let extra = shipmentCount % palletBoxCount;
    const tag = shipmentGroup.tag ? ` - ${shipmentGroup.tag}` : '';
    carrierAccountName = name;

    for (let j = 0; j < palletBoxCount; j++) {
      const suffix = palletBoxCount > 1 ? ` - ${j + 1}` : '';
      const palletBoxName = `${name}${tag} @${timestamp}${suffix}`;

      yield {
        id,
        palletBoxName,
        carrierAccountName,
        shipmentLimit: shipmentLimit + extra,
      };
      extra = 0;
    }
  }
}
